import { SalePlanningTask, SalePlanningTaskIndex } from "./PlanningTaskData";
import { AgTechIndex, Index } from "@agtech/core/utilities/AgTechUtilities";
import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";

export const PlanningTaskDataGetSaleTasksQuery: AgTechQuery<{ saleId: number }, SalePlanningTaskIndex> = {
    queryKey: ({ saleId }) => ['SalePlanningTasks', saleId],
    query: (props) => {
        return props.http.getEntity<SalePlanningTask[], AgTechIndex<SalePlanningTask>>({
            request: 'Sales/' + props.inputData.saleId + '/PlanningTasks',
            convert: tasks => Index(tasks, task => task.id)
        });
    },
    content: {
        loadingText: 'Loading planning tasks...',
        failureText: 'Failed to load planning tasks.'
    }
}

// Cross-sale "assigned to me" list - backed by GET api/Sales/MyPlanningTasks, which is scoped to
// the current user rather than any one sale (see SalesController.GetMyPlanningTasks).
export const PlanningTaskDataGetMyTasksQuery: AgTechQuery<any, SalePlanningTaskIndex> = {
    queryKey: () => ['MyPlanningTasks'],
    query: (props) => {
        return props.http.getEntity<SalePlanningTask[], AgTechIndex<SalePlanningTask>>({
            request: 'Sales/MyPlanningTasks',
            convert: tasks => Index(tasks, task => task.id)
        });
    },
    content: {
        loadingText: 'Loading your planning tasks...',
        failureText: 'Failed to load your planning tasks.'
    }
}
